import axios from '@/utils/axios'

// 加入提醒夹
export function ProductFavoriteAdd (data = {}) {
  return axios({
    url: '/SaleV2/ProductFavorite/ProductFavoriteAdd',
    method: 'post',
    data: data
  })
}

// 移出提醒夹
export function IsSetRemind (data = {}) {
  return axios({
    url: '/SaleV2/ProductFavorite/IsSetRemind',
    method: 'post',
    data: data
  })
}

// 商品提醒夹列表
export function GetProductFavoriteList (data = {}) {
  return axios({
    url: '/SaleV2/ProductFavorite/GetProductFavoriteList',
    method: 'post',
    data: data
  })
}

// 删除提醒夹商品
export function DeleteProductFavorite (data = {}) {
  return axios({
    url: '/SaleV2/ProductFavorite/DeleteProductFavorite',
    method: 'post',
    data: data
  })
}

// 收藏夹批量删除接口
export function MultiDeleteProductFavorite (data = {}) {
  return axios({
    url: '/SaleV2/ProductFavorite/MultiDeleteProductFavorite',
    method: 'post',
    data: data
  })
}

// // 取消提醒
// export function CancelProductRemind (data = {}) {
//   return axios({
//     url: '/SaleV2/ProductFavorite/CancelProductRemind',
//     method: 'post',
//     data: data
//   })
// }

// // 确认取消多节点
// export function CancelProductRemindNodes (data = {}) {
//   return axios({
//     url: '/SaleV2/ProductFavorite/CancelProductRemindNodes',
//     method: 'post',
//     data: data
//   })
// }

// // 获取提醒我节点
// export function GetProductRemindNodes (data = {}) {
//   return axios({
//     url: '/SaleV2/ProductFavorite/GetProductRemindNodes',
//     method: 'post',
//     data: data
//   })
// }

// // 设置提醒我节点
// export function SetRemindMe (data = {}) {
//   return axios({
//     url: '/SaleV2/ProductFavorite/SetRemindMe',
//     method: 'post',
//     data: data
//   })
// }

// // 0元抢购取消提醒
// export function OneCancelProductRemind (data = {}) {
//   return axios({
//     url: '/SaleV2/ProductFavorite/OneCancelProductRemind',
//     method: 'post',
//     data: data
//   })
// }

// 失效商品获取
export function GetProductFavoriteInvalidList (data = {}) {
  return axios({
    url: '/SaleV2/ProductFavorite/GetProductFavoriteInvalidList',
    method: 'post',
    data: data
  })
}

// 清空失效商品
export function InvalidProductFavoriteRemove (data = {}) {
  return axios({
    url: '/SaleV2/ProductFavorite/InvalidProductFavoriteRemove',
    method: 'post',
    data: data
  })
}
